import React, { useState } from 'react'
import GridMasonry from './gridMasonry'
import './login.view.css'
import LoginForm from './forms/loginForm';
import RegisterForm, { RegisterFormHeading } from './forms/registerForm';
import ForgotPasswordForm, { ForgotPasswordHeading } from './forms/forgotPasswordForm';
import { Grid } from '@material-ui/core';
import { LogoA3, LogoeTicketHorizontal } from '../../../assets/logos';
import { DialogPoliticyPrivacy, DialogTermsCond } from '../../pures';
import { useTranslation } from 'react-i18next';

import imageLogin1 from '../../../assets/logos/login1.png'
import imageLogin2 from '../../../assets/logos/login2.png'
import imageLogin3 from '../../../assets/logos/login3.png'
import imageLogin5 from '../../../assets/logos/login5.jpg'
import imageLogin7 from '../../../assets/logos/login7.jpeg'



const DUMMY_IMAGES = [
    imageLogin1,
    imageLogin2,
    imageLogin3,
    imageLogin5,
    imageLogin7,
]

export default function LoginView(props) {
    const { t, i18n } = useTranslation();

    const [modalTermsCond, setModalTermsCond] = useState(null);
    const [modalPolicityPrivacy, setModalPolicityPrivacy] = useState(null);
    const openModalTermsCond = (value) => {
        setModalTermsCond(value);
    };

    const openModalPolicityPrivacy = (value) => {
        setModalPolicityPrivacy(value);
    };

    const changeLanguage = (e) => {
        if (e.target.checked) {
            i18n.changeLanguage('es-MX');
        } else {
            i18n.changeLanguage('en');
        }
    }

    let heading = null;
    let content = null;

    switch (props.templateRendering) {
        case "login":
            content = <LoginForm {...props} />
            break;
        case "register":
            heading = <RegisterFormHeading handleBack={() => props.onHandleSelectTemplate("login")} />
            content = <RegisterForm {...props} openModalTermsCond={openModalTermsCond} openModalPolicityPrivacy={openModalPolicityPrivacy} />
            break;
        case "forgotPassword":
            heading = <ForgotPasswordHeading handleBack={() => props.onHandleSelectTemplate("login")} />
            content = <ForgotPasswordForm {...props} />
            break;
    }

    return (
        <>
            <div className='login-view-wrapper'>
                <Grid container className='login-view'>
                    <Grid item xs={false} md={6} style={{ height: "100%" }}>
                        <GridMasonry
                            title={t("loginView.labelRegisterSubtitleWelcome")}
                            arrayImages={DUMMY_IMAGES}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} className="login">
                        <Grid container className="login-container">
                            <Grid item xs={12} className="login-logo">
                                <img
                                    src={LogoeTicketHorizontal}
                                    alt={"Logo govo.legal"}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container className="loginForm">
                                    {heading}

                                    {/* MESSAGES */}
                                    {props.errorForm === true ? (
                                        <Grid item xs={12}>
                                            <div className="loginForm-message-container error">
                                                <p className="loginForm-message-label">{props.errorMessage}</p>
                                                <button
                                                    className="loginForm-message-close"
                                                    onClick={props.onHandleHideError}
                                                >
                                                    <i className="fas fa-times" />
                                                </button>
                                            </div>
                                        </Grid>
                                    ) : null}

                                    {/* SUCCESS MESSAGES */}
                                    {props.successForm === true ? (
                                        <Grid item xs={12}>
                                            <div className="login-container-success-label">
                                                <p className="login-success-label">
                                                    <span>{props.successMessage}</span>
                                                </p>
                                            </div>
                                        </Grid>
                                    ) : null}

                                    {content}
                                </Grid>
                            </Grid>

                            <Grid item xs={12} className="login-footer">
                                <img
                                    src={LogoA3}
                                    alt={"Logo govo.legal"}
                                />
                                <p>{t("loginView.aServiceCreatedBy")} {t("loginView.textA3Microservice")}</p>
                            </Grid>

                            <label className="loginView-language" htmlFor="language-switch">
                                <input id='language-switch' className='loginView-language-checkbox' type="checkbox" value={i18n.language === 'es-MX'} onClick={changeLanguage} />
                                <span className="k-icon k-font-icon k-i-globe-outline"></span>
                                <span className={i18n.language === 'en' ? 'loginView-language-selected' : ''}>EN</span> | <span className={i18n.language === 'es-MX' ? 'loginView-language-selected' : ''}>ES</span>
                            </label>
                        </Grid>
                    </Grid>
                </Grid>


                <DialogTermsCond
                    modalTermsCond={modalTermsCond}
                    openModalTermsCond={openModalTermsCond}
                />
                <DialogPoliticyPrivacy
                    modalPolicityPrivacy={modalPolicityPrivacy}
                    openModalPolicityPrivacy={openModalPolicityPrivacy}
                />
            </div>
        </>
    )
}
